import {
	Box,
	createTheme,
	ThemeProvider,
	ToggleButton,
	ToggleButtonGroup,
	Typography,
} from "@mui/material";
import React, { useState } from "react";
import "./styles.css";
import TopicsPanel from "../../components/TopicsPanel";
import UsersPanel from "../../components/UsersPanel";
import MainUsersPanel from "../../components/MainUsersPanel";
import { useClientAccessContext } from "../../context/ClientAccessContext";
import { GlobalUserRole } from "../../context/ClientAccessContext/types";
import { globalBg, grayscaleBg, grayscaleGrayDark } from "../../styles/theme";
import GenericNavItem from "../../components/GenericNavItem";
import { useAdminPanelContext } from "../../context/AdminPanelContext";
import { PanelId } from "../../context/PanelContext";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";

enum PanelToggleOptions {
	CLIENT_USERS = "Client Users",
	MAIN_USERS = "Main Users",
	TOPICS = "Topics",
}

const Admin = () => {
	const { userWithClients } = useClientAccessContext();
	const { selectedConfigId } = useAdminPanelContext();
	const [selectedPanel, setSelectedPanel] = useState<PanelToggleOptions>(
		PanelToggleOptions.TOPICS
	);

	const handlePanelChange = (event, newValue) => {
		setSelectedPanel(newValue);
	};

	return (
		<Box>
			<ThemeProvider theme={toggleButtonTheme}>
				<Box
					sx={{
						height: "61px",
						width: "100%",
						display: "flex",
						backgroundColor: grayscaleBg,
						borderTop: "1px solid" + globalBg,
						justifyContent: "space-between",
					}}
				>
					<ToggleButtonGroup
						fullWidth
						color="primary"
						sx={{ width: "fit-content", borderRadius: "0" }}
						value={selectedPanel}
						exclusive
						onChange={handlePanelChange}
					>
						{userWithClients.globalRole === GlobalUserRole.ADMIN && (
							<ToggleButton
								key={PanelToggleOptions.MAIN_USERS}
								value={PanelToggleOptions.MAIN_USERS}
							>
								<Typography sx={{ textTransform: "none" }}>
									{PanelToggleOptions.MAIN_USERS}
								</Typography>
							</ToggleButton>
						)}
						<ToggleButton
							key={PanelToggleOptions.CLIENT_USERS}
							value={PanelToggleOptions.CLIENT_USERS}
							sx={{ flexGrow: 1 }}
						>
							<Typography sx={{ textTransform: "none" }}>
								{PanelToggleOptions.CLIENT_USERS}
							</Typography>
						</ToggleButton>
						<ToggleButton
							key={PanelToggleOptions.TOPICS}
							value={PanelToggleOptions.TOPICS}
							sx={{ flexGrow: 1 }}
						>
							<Typography sx={{ textTransform: "none" }}>
								{PanelToggleOptions.TOPICS}
							</Typography>
						</ToggleButton>
					</ToggleButtonGroup>
					{selectedConfigId && (
						<Box sx={{ borderLeft: "1px solid " + globalBg }}>
							<GenericNavItem
								width="fit-content"
								Icon={AutoFixHighIcon}
								panelId={PanelId.SearchTerm}
							></GenericNavItem>
						</Box>
					)}
				</Box>
			</ThemeProvider>
			{selectedPanel === PanelToggleOptions.TOPICS && <TopicsPanel />}
			{selectedPanel === PanelToggleOptions.CLIENT_USERS && <UsersPanel />}
			{selectedPanel === PanelToggleOptions.MAIN_USERS && <MainUsersPanel />}
		</Box>
	);
};

const toggleButtonTheme = createTheme({
	components: {
		MuiToggleButton: {
			styleOverrides: {
				root: {
					minWidth: "200px",
					borderTop: "none",
					borderBottom: "none",
					borderRadius: "0!important",
					borderRight: "1px solid " + globalBg,
					"&.Mui-selected": {
						backgroundColor: grayscaleGrayDark + "!important",
						color: "white",
					},
					"&:hover": {
						backgroundColor: grayscaleBg,
						borderRight: "1px solid " + globalBg + "!important",
						borderLeft: "1px solid " + globalBg + "!important",
					},
				},
			},
		},
	},
});

export default Admin;
